import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import MuiFlatButton from '@mui/material/Button';
import useIsMobile from 'lib/useIsMobile';
/* eslint-disable */
const useStyles = makeStyles(theme => ({
  label: props => ({
    fontSize: props.isSmall ? 10 : 12,
    paddingLeft: props.icon ? 0 : 8,
    paddingRight: 8,
    color: theme.palette.text.primary,
    ...props.labelStyle,
  }),
  icon: {
    marginRight: '0px !important',
  },
}));

const FlatButton = ({
  forceLabel,
  icon,
  iconStyle,
  label,
  labelStyle,
  small,
  style,
  title,
  lableColor,
  ...props
}) => {
  const mobile = useIsMobile();
  const isSmall = useMemo(() => {
    if (typeof small === 'boolean') {
      return small;
    }
    return !mobile;
  }, [mobile, small]);
  const styles = useStyles({ isSmall, icon, labelStyle });
  const iconSize = useMemo(() => (isSmall ? 16 : 20), [isSmall]);
  const height = useMemo(() => (isSmall ? 24 : 36), [isSmall]);

  return (
    <MuiFlatButton
      {...props}
      startIcon={useMemo(
        () =>
          icon &&
          React.cloneElement(icon, {
            style: {
              marginLeft: 8,
              marginRight: 2,
              width: iconSize,
              height: iconSize,
              ...iconStyle,
            },
          }),
        [icon, iconSize, iconStyle]
      )}
      classes={{ label: styles.label, icon: styles.icon }}
      style={useMemo(
        () => ({
          height,
          lineHeight: `${height}px`,
          marginRight: 0,
          minWidth: 0,
          padding: 0,
          ...style,
        }),
        [height, style]
      )}
      title={useMemo(() => title || label, [label, title])}
    >
      {label && (
        <span style={{ color: lableColor, marginLeft: 2 }}>
          {useMemo(() => (!mobile || forceLabel ? label : null), [
            forceLabel,
            label,
            mobile,
          ])}
        </span>
      )}
    </MuiFlatButton>
  );
};

FlatButton.propTypes = {
  ...MuiFlatButton.propTypes,
  forceLabel: PropTypes.bool,
  icon: PropTypes.node,
  iconStyle: PropTypes.object,
  label: PropTypes.string,
  labelStyle: PropTypes.object,
  small: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string,
  lableColor: PropTypes.string,
};

export default FlatButton;
